/** Raw `processing_status` values that represent terminal failure states. */
export const FAILURE_STATUSES = new Set([
  "failed",
  "conversion_failed",
  "ocr_failed",
  "chunking_failed",
  "embedding_failed",
  "timeout_failed",
  "upload_failed",
  "transfer_failed",
]);

/** Human-readable labels for each failure status. */
export const FAILURE_LABELS: Record<string, string> = {
  failed: "Processing Failed",
  conversion_failed: "Conversion Failed",
  ocr_failed: "OCR Failed",
  chunking_failed: "Chunking Failed",
  embedding_failed: "Embedding Failed",
  timeout_failed: "Timeout",
  upload_failed: "Upload Failed",
  transfer_failed: "Transfer Failed",
};

/** Valid MUI Chip/Alert color tokens (excludes CoreUI-only values like "danger"). */
export type MuiColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

/** CoreUI CAlert color token mapped from is_retryable. */
export type CoreUiAlertColor = "danger" | "info" | "warning";

/** MUI Chip color for each raw `processing_status` value. */
export const STATUS_COLORS: Record<string, MuiColor> = {
  uploaded: "info",
  converting_to_pdf: "primary",
  pdf_conversion_complete: "primary",
  ocr_detection: "secondary",
  ocr_processing: "secondary",
  ocr_complete: "secondary",
  chunking: "warning",
  chunking_complete: "warning",
  embedding: "primary",
  embedding_complete: "primary",
  indexing: "info",
  completed: "success",
  failed: "error",
  conversion_failed: "error",
  ocr_failed: "error",
  chunking_failed: "error",
  embedding_failed: "error",
  timeout_failed: "error",
  upload_failed: "error",
  transfer_failed: "error",
  suspected_orphan: "warning",
  no_processing_needed: "default",
  null: "default",
  pending: "warning",
};
